// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3KMie","list":"BalanceDue_list__2DyAP","listRow":"BalanceDue_listRow__2xMun","total":"BalanceDue_total__Rmsx8"};